// Author thq
// Date 2024-02-21 10:33:26

import * as model from "@/model/em/statusCollection/TpmMonitorProgramStatusTmoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.TpmMonitorProgramStatusTmo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
